import { COMP_IMAGE_EDITOR, uploadArea, TEX_SIZE, MAX_UPLOAD_SIZE_MB } from "../constants";

export class UploadComponent {
  constructor(parent) {
    this._initialized = false;
    this.parent = parent;
    this.transform = {
      flipH: 0,
      flipV: 0,
      rotation: 0,
      scale: 1,
      x: 0,
      y: 0
    }
  }

  displayState(state) {
    this.$ui.find('.state').removeClass('active');
    this.$ui.find(`.state[data-state=${state}]`).addClass('active');
  }

  async init() {
    if (this._initialized) {
      return;
    }

    const me = this;
    this.$ui = this.parent.$container.find('.upload-ui');
    const side = this.parent.$container.attr('data-side');
    const layer = this.parent.$container.attr('data-layer');
    const $errorMsg = this.$ui.find('.error-msg');
    const $progress = this.$ui.find('.progress-bar');
    const $fileLine = this.$ui.find('.state[data-state=file] .file');
    const $fileRemove = this.$ui.find('.state[data-state=file] .btn-primary');
    const $fileInput = this.$ui.find(':file');
    const $editBtn = this.$ui.find('.state[data-state=file] .btn-edit');
    const $doneBtn = this.$ui.find('.state[data-state=file] .btn-done');

    this.editor = this.parent.components.get(COMP_IMAGE_EDITOR);
    this.editor.$ui.on('editor-update', me.updateImageTransform.bind(this));

    $editBtn.click(function () {
      me.editor.setValues(me.transform);
      me.editor.show(
        me.updateImageTransform.bind(me),
        me.parent.$container,
        side
      );
    });
    $doneBtn.click(function () {
      me.editor.hide();
      // move onto next category
      let $next = me.parent.$container.next().next(':not(.blacklisted)');
      $next.addClass("enabled");
      me.parent.controller._moveNextCategory(me.parent.$container, "Swatch Gallery", true, $next);
    });

    this.parent.controller.on('category-open', function (e, $cat) {
      if ($cat !== me.parent.$container) {
        if (me.editor.$activeContainer == me.parent.$container) {
          me.editor.hide();
        }
      }
    })


    // setup login btn action or move ui state to ready
    this.$ui.find('.btn-login').click(function () {
      const group = me.parent.$container.find('.swatch-group-btn.active').attr('data-name');
      window.location.hash = `${me.parent.id}/${group}`;
      me.parent.controller.requireLogin();
    });

    if (frappe.is_user_logged_in()) {
      this.displayState('ready');
    }

    // DEBUG Canvas
    // this.$canvas = $(`<canvas width="${TEX_SIZE}" height="${TEX_SIZE}"></canvas>`);
    // this.$canvas.css({
    //   "position": "fixed",
    //   "left": "0",
    //   "bottom": side=='left'?'256px':'0',
    //   "width": "256px",
    //   "height": "256px",
    //   "border": "1px solid red"
    // });
    // $('body').append(this.$canvas);

    const texOptions = {
      width: TEX_SIZE,
      height: TEX_SIZE
    };

    this.maskTexture = await me.parent.controller.designer.textureFromCanvas(`${me.parent.id}-${side}-mask`, texOptions);
    this.colorTexture = await me.parent.controller.designer.textureFromCanvas(`${me.parent.id}-${side}-color`, texOptions);
    this.normalTexture = await me.parent.controller.designer.textureFromCanvas(`${me.parent.id}-${side}-normal`, texOptions);
    this.metallicTexture = await me.parent.controller.designer.textureFromCanvas(`${me.parent.id}-${side}-metallic`, texOptions);

    const maskCtx = this.maskTexture.getContext();
    const colorCtx = this.colorTexture.getContext();
    const normalCtx = this.normalTexture.getContext();
    const metallicCtx = this.metallicTexture.getContext();

    let maskResolve;
    let maskPromise = new Promise((resolve) => { maskResolve = resolve; });
    let maskImg = this.maskImg = new Image();
    maskImg.crossOrigin = "Anonymous";
    maskImg.onload = function () { maskResolve(); }
    maskImg.src = me.parent.controller.settings[`tex_fp_mask_${side}`];
    await maskPromise; // wait for mask to load

    // setup upload input action
    $fileInput.change(function (e) {
      $errorMsg.slideUp('fast');

      let file = e.target.files[0];
      let maxBytes = MAX_UPLOAD_SIZE_MB * 1048576;
      let process = true;
      if (file.size > maxBytes) {
        $errorMsg.slideOut('fast');
        $errorMsg.text(`Maximum file size allowed is ${MAX_UPLOAD_SIZE_MB}Mb`);
        process = false;
      }

      if (process) {
        me.loadImage(file);
      }
    });

    // handle clearing uploaded image
    $fileRemove.click((e) => this.removeUpload(e));

    this._initialized = true;
  }

  async loadImage(file, url, file_name, hide_editor, apply_material) {
    if (apply_material === undefined) {
      apply_material = true;
    }

    const me = this;
    this.$ui = this.parent.$container.find('.upload-ui');
    const side = this.parent.$container.attr('data-side');
    const layer = this.parent.$container.attr('data-layer');
    const $errorMsg = this.$ui.find('.error-msg');
    const $progress = this.$ui.find('.progress-bar');
    const $fileLine = this.$ui.find('.state[data-state=file] .file');
    const $fileRemove = this.$ui.find('.state[data-state=file] .btn-primary');
    const $fileInput = this.$ui.find(':file');
    const $editBtn = this.$ui.find('.state[data-state=file] .btn-edit');
    const $doneBtn = this.$ui.find('.state[data-state=file] .btn-done');

    this.editor = this.parent.components.get(COMP_IMAGE_EDITOR);
    this.editor.$ui.on('editor-update', me.updateImageTransform.bind(this));

    me.displayState('processing');
    $progress.width = "10%";
    let _resolve = null;
    let _reject = null;
    let promise = new Promise((resolve, reject) => {
      _resolve = resolve;
      _reject = reject;
    });

    let img = me.img = new Image();
    img.crossOrigin = "Anonymous";

    img.onerror = function (err) {
      _reject(err)
    };

    img.onload = async function () {

      me.maskShapeCanvas = document.createElement("canvas");
      me.maskShapeCanvas.width = img.width;
      me.maskShapeCanvas.height = img.height;

      // get faceplate image area depending on side
      me.x = uploadArea[side].x;
      me.y = uploadArea[side].y;
      me.w = uploadArea[side].w;
      me.h = uploadArea[side].h;

      // scale area to texture size
      me.dx = me.x * TEX_SIZE;
      me.dy = me.y * TEX_SIZE;
      me.dw = me.w * TEX_SIZE;
      me.dh = me.h * TEX_SIZE;

      // keep source image aspect ratio and center in upload area.
      if (img.width > img.height) {
        me.dh = me.dw * (img.height / img.width);
        //me.dy = me.dy + (((me.h * TEX_SIZE) - me.dh) / 2);
      } else if (img.width < img.height) {
        me.dw = me.dh * (img.width / img.height);
        //me.dx = me.dx + (((me.w * TEX_SIZE) - me.dw) / 2);
      }

      // create image shape mask from alpha on the fly
      const maskShapeCtx = me.maskShapeCanvas.getContext("2d");
      maskShapeCtx.save();
      // Fill color
      maskShapeCtx.fillStyle = "#000000";
      maskShapeCtx.fillRect(0, 0, img.width, img.height);

      // mask out image
      maskShapeCtx.globalCompositeOperation = "destination-out";
      maskShapeCtx.drawImage(img, 0, 0, img.width, img.height);

      // fill empty void with white
      maskShapeCtx.globalCompositeOperation = "destination-over";
      maskShapeCtx.fillStyle = "#ffffff";
      maskShapeCtx.fillRect(0, 0, img.width, img.height);

      maskShapeCtx.restore();


      if (!hide_editor) {
        const editor = me.parent.components.get(COMP_IMAGE_EDITOR);

        editor.setValues(me.transform);
        editor.show(
          me.updateImageTransform.bind(me),
          me.parent.$container,
          side
        );
      }

      // visually show progress at 100%
      $progress.width = "100%";

      if (file) {
        // destroy base64 image encoded in url to avoid memory leaks
        URL.revokeObjectURL(img.src);

        // set file name on ui
        $fileLine.text(file.name);
      } else {
        $fileLine.text(file_name);
      }
      me.displayState('file');

      // build art material on the fly
      const mat = {
        base_color: '#fff',
        [`tex_${side}_mask`]: `canvas://${me.parent.id}-${side}-mask`,
        [`tex_${side}_color`]: `canvas://${me.parent.id}-${side}-color`,
        [`tex_${side}_normal`]: `canvas://${me.parent.id}-${side}-normal`,
        [`tex_${side}_metallic`]: `canvas://${me.parent.id}-${side}-metallic`,
        [`tex_${side}_emissive`]: undefined,
      }

      // finally apply material
      if (apply_material) {
        await me.parent.controller.updateMaterial(mat, side, layer);
      }

      // hide swatch colors selections when uploading an image
      const $colors = me.parent.$container
        .parent()
        .find(`[data-parent=${me.parent.id}]`);

      if ($colors.length > 0) {
        $colors.hide();
        $colors.removeClass('has-selection');
        $colors.removeClass('enabled');
        $colors.find('.swatch.active').removeClass('active');
      }

      // enable next category, flag this one as having data and reset any swatch selections.
      me.parent.$container.addClass('has-selection');
      me.parent.$container.addClass('has-upload');
      me.parent.$container.find('.swatch.active').removeClass('active');
      me.parent.$container.find('.label').text(`: Custom`);
      me.parent.$container.find('.icon').css('background-image', '');
      // record uploaded file on respective side
      if (file) {
        me.parent.controller.files[side] = file;
        me.parent.controller.state.custom_art[side] = {
          file_name: file.name,
          url
        };
      } else {
        // used to syntactically load uploaded images during edit mode
        me.parent.controller.files[side] = {
          name: file_name,
          synthetic: true
        };
        me.parent.controller.state.custom_art[side].file_name = file_name;
      }

      if (url && url != me.parent.controller.state.custom_art[side].url) {
        me.parent.controller.state.custom_art[side].url = url;
      } else if (!url && me.parent.controller.state.custom_art[side].url) {
        delete me.parent.controller.state.custom_art[side].url;
      }

      me.parent.components.broadcast('onUpdatePrice', this);
      me.parent.controller.validate();
      me.parent.controller.updatePrice();

      _resolve();
    }

    if (file) {
      img.src = URL.createObjectURL(file);
    }

    if (url) {
      img.src = url;
    }

    const result = await promise;
    this.updateImageTransform();
    await this.parent.components.asyncBroadcast("on_image_uploaded", file, url, file_name, hide_editor, apply_material, side, layer);
    return result;
  }

  async removeUpload(e) {
    const side = this.parent.$container.attr('data-side');
    const layer = this.parent.$container.attr('data-layer');

    this.parent.controller.state.custom_art[side] = false;

    const $fileLine = this.$ui.find('.state[data-state=file] .file');
    const $fileInput = this.$ui.find(':file');

    const maskCtx = this.maskTexture.getContext();
    const colorCtx = this.colorTexture.getContext();
    const normalCtx = this.normalTexture.getContext();
    const metallicCtx = this.metallicTexture.getContext();

    maskCtx.restore();
    colorCtx.restore();
    normalCtx.restore();
    metallicCtx.restore();

    maskCtx.globalCompositeOperation = 'source_over';
    maskCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
    colorCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
    normalCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
    metallicCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);

    this.maskTexture.update();
    this.colorTexture.update();
    this.normalTexture.update();
    this.metallicTexture.update();

    await this.parent.controller.updateMaterial({
      base_color: '#fff'
    }, side, layer);

    $fileInput.val('');
    $fileLine.text('');
    this.parent.$container.find('.price').text('');
    this.displayState('ready');
    this.editor.hide();

    this.parent.components.broadcast('onUpdatePrice', this);
    this.parent.controller.validate();
    this.parent.controller.updatePrice();
  }

  updateImageTransform(transform) {
    const side = this.parent.$container.attr('data-side');

    this.transform = Object.assign(this.transform, transform || {});
    this.parent.controller.state.custom_art[side] = Object.assign(
      this.parent.controller.state.custom_art[side] || {}, this.transform);

    const maskCtx = this.maskTexture.getContext();
    const colorCtx = this.colorTexture.getContext();
    const normalCtx = this.normalTexture.getContext();
    const metallicCtx = this.metallicTexture.getContext();
    const maskShapeCtx = this.maskShapeCanvas.getContext("2d");

    // restore canvas context stack to defaults.
    maskCtx.restore();
    colorCtx.restore();
    normalCtx.restore();
    metallicCtx.restore();

    // save defaults in the stack for next time this is called.
    maskCtx.save();
    colorCtx.save();
    normalCtx.save();
    metallicCtx.save();

    // draw layers ////////////////////////////////////

    const ax = uploadArea[side].x * TEX_SIZE;
    const ay = uploadArea[side].y * TEX_SIZE;
    const aw = uploadArea[side].w * TEX_SIZE;
    const ah = uploadArea[side].h * TEX_SIZE;

    const w = this.img.width;
    const h = this.img.height;
    const scaleX = (this.dw / w) * this.transform.scale * (this.transform.flipH ? -1 : 1);
    const scaleY = (this.dh / h) * this.transform.scale * (this.transform.flipV ? -1 : 1);
    const x = ax + (aw / 2); // center image on faceplate area
    const y = ay + (ah / 2);
    const hw = w / 2;
    const hh = h / 2;
    const angle = (this.transform.rotation * Math.PI) / 180;
    const moveScale = 1.7;
    const mx = this.transform.x * moveScale;
    const my = this.transform.y * moveScale;
    const tx = Math.cos(-angle) * mx -
      Math.sin(-angle) * my;
    const ty = Math.sin(-angle) * mx +
      Math.cos(-angle) * my;
    const offsetX = -hw + (tx * (1 / scaleX));
    const offsetY = -hh + (ty * (1 / scaleY));

    const applyTransform = (ctx, x, y, angle, scaleX, scaleY) => {
      // move origin to where we want to rotate about
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.scale(scaleX, scaleY);
    }

    colorCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
    applyTransform(colorCtx, x, y, angle, scaleX, scaleY);

    // diffuse layer, avoid transparencies by pre coloring a block
    colorCtx.fillStyle = "#ffffff";
    //colorCtx.fillRect(this.dx, this.dy, this.dw, this.dh);
    colorCtx.fillRect(offsetX, offsetY, w, h);
    // draw user image
    colorCtx.drawImage(this.img, offsetX, offsetY);
    //colorCtx.drawImage(this.img, 0, 0, this.img.width, this.img.height, this.dx, this.dy, this.dw, this.dh);
    colorCtx.restore();

    // draw default normal

    normalCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
    applyTransform(normalCtx,
      x, y, angle,
      scaleX, scaleY
    );
    normalCtx.fillStyle = '#0000FF';
    normalCtx.fillRect(offsetX, offsetY, w, h);

    // draw default metal and rough
    metallicCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
    applyTransform(metallicCtx,
      x, y, angle,
      scaleX, scaleY
    );
    metallicCtx.fillStyle = '#00ff00';
    metallicCtx.fillRect(offsetX, offsetY, w, h);

    // combine faceplate mask and image mask to clip using the faceplate mask
    maskCtx.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
    maskCtx.fillStyle = '#000000';
    maskCtx.fillRect(0, 0, TEX_SIZE, TEX_SIZE);

    maskCtx.save();
    applyTransform(maskCtx,
      x, y, angle,
      scaleX, scaleY
    );
    maskCtx.fillStyle = '#ffffff';
    maskCtx.fillRect(offsetX, offsetY, w, h);
    maskCtx.drawImage(this.maskShapeCanvas, offsetX, offsetY, w, h);
    maskCtx.restore();

    maskCtx.globalCompositeOperation = 'multiply';
    maskCtx.drawImage(this.maskImg, 0, 0, TEX_SIZE, TEX_SIZE);

    // update webgl texture
    this.maskTexture.update();
    this.colorTexture.update();
    this.normalTexture.update();
    this.metallicTexture.update();

    this.parent.controller.designer.updateDynamicTextures("iem", [side]);
  }

  async activateSwatchGroup($swatchGroup) {
    const name = $swatchGroup.attr('data-name');
    const side = this.parent.$container.attr('data-side');
    const layer = this.parent.$container.attr('data-layer');

    if (name != 'upload' && this.parent.$container.hasClass('has-upload')) {
      this.parent.$container.removeClass('has-upload');
      this.removeUpload();
      this.parent.$container.find('.label').text(``);

      const $colors = this.parent.$container.parent().find(`[data-parent=${this.parent.id}]`);
      if ($colors.length > 0) {
        $colors.addClass('enabled');
      }
      this.parent.$container.addClass('active');
      this.parent.$container.removeClass('has-selection');
    } else if (name == 'upload') {
      // hide swatch colors selections when uploading an image
      const $colors = this.parent.$container
        .parent()
        .find(`[data-parent=${this.parent.id}]`);

      if ($colors.length > 0) {
        $colors.hide();
        $colors.removeClass('has-selection');
        $colors.removeClass('enabled');
        $colors.find('.swatch.active').removeClass('active');
      }

      // enable next category, flag this one as having data and reset any swatch selections.
      // this.parent.controller._enableNextCategory(this.parent.$container, true);
      this.parent.$container.addClass('has-selection');
      this.parent.$container.addClass('has-upload');
      this.parent.$container.find('.swatch.active').removeClass('active');

      await this.parent.controller.updateMaterial({
        base_color: '#fff'
      }, side, layer);
    }
  }

  async loadState(matLayers, state) {
    console.log("[UPLOAD] loadState: ", matLayers, state);
    const me = this;
    this.$ui = this.parent.$container.find('.upload-ui');
    const side = this.parent.$container.attr('data-side');
    const layer = this.parent.$container.attr('data-layer');
    let art_url = state.custom_art[side] && state.custom_art[side].url;
    if (side === "right" && state.custom_art.right && !state.custom_art.right.url && state.custom_art.left.url) {
      art_url = state.custom_art.left.url;
    }

    console.log("???Load custom art on: ", side, art_url);
    if (art_url) {

      this.parent.$container.find('.swatch-group').removeClass('active');

      const $uploadUIGroup = this.parent.$container.find('.swatch-group[data-name=upload]');
      const $categories = this.parent.$container.find('.categories');
      const $catButtons = $categories.find('.swatch-group-btn');
      $uploadUIGroup.addClass('active');
      $uploadUIGroup.siblings().removeClass('active');
      $catButtons.removeClass('active');
      $catButtons.filter('[data-name=upload]').addClass('active');

      this.parent.$container.addClass('enabled');
      this.parent.$container.addClass('collapsed');

      await this.loadImage(null, art_url, state.custom_art[side].file_name, true, true)
      const transform = Object.assign({}, state.custom_art[side]);
      // keep transform clean from art url and file info
      if ("file_name" in transform) {
        delete transform.file_name;
      }
      if ("url" in transform) {
        delete transform.url;
      }
      if ("requires_artwork" in transform) {
        delete transform.requires_artwork;
      }
      this.updateImageTransform(transform)

      this.parent.components.broadcast('onUpdatePrice', this);
      this.parent.controller.validate();
      this.parent.controller.updatePrice();
    }
  }

  async activateSwatch($swatch, matLayers, updateState) {
  }

}